// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.field-label[data-v-d37992e6] {\n\tfont-size: 0.8rem;\n}\n\t\n", ""]);
// Exports
module.exports = exports;
